const config = require("config");

(function () {
  "use strict";
  var serviceId = "routeSyncService";

  angular
    .module("app")
    .service("routeSyncService", routeSyncService);

  routeSyncService.$inject = [
    "VehicleGroups",
    "RoutingProfiles",
    "Vehicles",
    "$http"
  ];

  function routeSyncService(VehicleGroups, RoutingProfiles, Vehicles, $http) {
    return {
      getVehicleGroups: getVehicleGroups,
      getRoutingProfilesForVehicleGroup: getRoutingProfilesForVehicleGroup,
      getVehiclesForVehicleGroup: getVehiclesForVehicleGroup,
      getVehicles: getVehicles,
      sendRouteSyncMessage: sendRouteSyncMessage
    };

    ////////////////

    /** getVehicles
     *  Returns the valid vehicles for the currently logged in user
     * @returns {Promise} Promise to get all vehicles
     */
    function getVehicles() {
      let request = {
        url: config.daUrl + "routesync-user"
      };

      return _sendRequest(request);
    }

    /** sendRouteSyncMessage
     *  Accepts a RouteSync object and posts it as a routesync message to data anywhere.
     * @param {Object} message - the RouteSync message
     */
    function sendRouteSyncMessage(message) {
      let request = {
        url: config.daUrl + "routesync-message",
        data: message,
        method: "POST"
      };

      return _sendRequest(request);
    }

    /** getVehicleGroups
     *  Returns the valid vehicle groups for the currently logged in user.
     * @param {String} filterString - string by which to filter vehicle group names. defaults to null.
     * @param {Object} pageOptions - options to control how results are paginated: Valid options include
     * pageNumber, limit, sortBy (which should be a string that is the name of a property of a vehicle group), and
     * sortAscending, which is a bool. Defaults to null.
     * Valid properties for the vehicle group are:
     * Id, Name, NumberOfVehicles
     */
    function getVehicleGroups(filterString = null, pageOptions = null) {
      return VehicleGroups.getVehicleGroups([], [], filterString, pageOptions);
    }

    /** getRoutingProfilesForVehicleGroup
     *  Returns the routing profiles for the given vehicle group ID.
     * @param {Number} vehicleGroupID  - id of the vehicle group for which we will retrieve routing profiles.
     */
    function getRoutingProfilesForVehicleGroup(vehicleGroupID) {
      return RoutingProfiles.getRoutingProfiles(vehicleGroupID);
    }

    /** getVehiclesForVehicleGroup
     *  Returns all of the vehicles part of the given vehicle group ID.
     * @param {Number} vehicleGroupID  - id of the vehicle group for which we will retrieve routing profiles.
     * @param {String} filterString - string by which to filter vehicle names. defaults to null.
     * @param {Object} pageOptions - options to control how results are paginated: Valid options include
     * pageNumber, limit, sortBy (which should be a string that is the name of a property of a vehicle group), and
     * sortAscending, which is a bool. Defaults to null.
     * Valid properties for the vehicle group are:
     * Id, Name, VehicleId
     */
    function getVehiclesForVehicleGroup(vehicleGroupID, filterString = null, pageOptions = null) {
      return Vehicles.getVehicles([
        vehicleGroupID
      ].filterString, pageOptions);
    }

    //  Service internals

    function _sendRequest(request) {
      return $http(request)
        .then((resp) => {
          return resp.data;
        });
    }
  }
})();



// WEBPACK FOOTER //
// ./app/route-sync/route-sync-utils/routeSync.service.js